const useCleverTap = () => {
  const clevertapId = process.env.REACT_APP_CLEVERTAP_ID || ''

  const initializeCleverTap = async () => {
    const { default: clevertap } = await import('clevertap-web-sdk');
    clevertap.privacy.push({ optOut: false });
    // Set the flag to true, if the user of the device opts out of sharing their data
    clevertap.privacy.push({ useIP: true }); // Set the flag to true, if the user agrees to share their IP data
    clevertap.init(clevertapId, 'in1'); // Replace with values applicable to you. Refer below
    clevertap.spa = true;
    clevertap.setLogLevel(3);
  };

  return { initializeCleverTap };
}

export default useCleverTap;
